export interface ConnectorPlugin {
  id: string
  connectorId: string // 'jira' | 'confluence' | 'github' | 'slack' | 'gcalendar' | 'gdrive' | 'gmail'
  name: string
  description: string
  icon: string // lucide icon name
  category: 'alerts' | 'automation' | 'insights' | 'sync'
  isNew?: boolean
  isPremium?: boolean
}
export const connectorPlugins: ConnectorPlugin[] = [
  // Jira
  {
    id: 'sprint-auto-report',
    connectorId: 'jira',
    name: 'Sprint Auto-Report',
    description: 'Genera resumen diario del sprint automáticamente',
    icon: 'FileText',
    category: 'automation',
  },
  {
    id: 'blocker-alerts',
    connectorId: 'jira',
    name: 'Blocker Alerts',
    description: 'Notifica cuando un issue lleva bloqueado más de 24h',
    icon: 'AlertTriangle',
    category: 'alerts',
  },
  {
    id: 'velocity-tracker',
    connectorId: 'jira',
    name: 'Velocity Tracker',
    description: 'Analiza la velocidad del equipo a lo largo del tiempo',
    icon: 'TrendingUp',
    category: 'insights',
  },
  {
    id: 'sla-monitor',
    connectorId: 'jira',
    name: 'SLA Monitor',
    description: 'Alertas de vencimiento de SLAs en tickets críticos',
    icon: 'Clock',
    category: 'alerts',
    isPremium: true,
  },
  {
    id: 'auto-assign',
    connectorId: 'jira',
    name: 'Auto-Assign',
    description: 'Asigna tickets automáticamente basado en carga de trabajo',
    icon: 'UserPlus',
    category: 'automation',
    isNew: true,
  },
  // Confluence
  {
    id: 'page-watcher',
    connectorId: 'confluence',
    name: 'Page Watcher',
    description: 'Alertas de cambios en páginas clave',
    icon: 'Eye',
    category: 'alerts',
  },
  {
    id: 'doc-freshness',
    connectorId: 'confluence',
    name: 'Doc Freshness',
    description: 'Identifica documentación desactualizada',
    icon: 'RefreshCw',
    category: 'insights',
  },
  {
    id: 'meeting-notes-summary',
    connectorId: 'confluence',
    name: 'Meeting Notes Summary',
    description: 'Extrae action items de minutas de reunión',
    icon: 'FileText',
    category: 'automation',
    isPremium: true,
  },
  // GitHub
  {
    id: 'pr-reminders',
    connectorId: 'github',
    name: 'PR Reminders',
    description: 'Recordatorios de PRs pendientes de revisión',
    icon: 'GitPullRequest',
    category: 'alerts',
  },
  {
    id: 'ci-cd-alerts',
    connectorId: 'github',
    name: 'CI/CD Alerts',
    description: 'Notificaciones de builds fallidos',
    icon: 'Rocket',
    category: 'alerts',
  },
  {
    id: 'code-review-metrics',
    connectorId: 'github',
    name: 'Code Review Metrics',
    description: 'Métricas de tiempo de revisión y tamaño de PRs',
    icon: 'BarChart',
    category: 'insights',
  },
  {
    id: 'dependency-alerts',
    connectorId: 'github',
    name: 'Dependency Alerts',
    description: 'Avisos de vulnerabilidades en dependencias',
    icon: 'ShieldAlert',
    category: 'alerts',
    isPremium: true,
  },
  // Slack
  {
    id: 'channel-digest',
    connectorId: 'slack',
    name: 'Channel Digest',
    description: 'Resumen diario de canales seleccionados',
    icon: 'List',
    category: 'automation',
  },
  {
    id: 'standup-bot',
    connectorId: 'slack',
    name: 'Standup Bot',
    description: 'Automatiza el daily standup asíncrono',
    icon: 'Bot',
    category: 'automation',
  },
  {
    id: 'thread-summarizer',
    connectorId: 'slack',
    name: 'Thread Summarizer',
    description: 'Resume hilos largos con IA',
    icon: 'MessageSquare',
    category: 'automation',
    isPremium: true,
  },
  // Google Calendar
  {
    id: 'meeting-prep',
    connectorId: 'gcalendar',
    name: 'Meeting Prep',
    description: 'Prepara contexto y documentos antes de reuniones',
    icon: 'FileText',
    category: 'automation',
  },
  {
    id: 'availability-sync',
    connectorId: 'gcalendar',
    name: 'Availability Sync',
    description: 'Sincroniza estado de Slack con eventos del calendario',
    icon: 'RefreshCw',
    category: 'sync',
  },
  {
    id: 'meeting-cost',
    connectorId: 'gcalendar',
    name: 'Meeting Cost Calculator',
    description: 'Calcula el costo estimado de las reuniones',
    icon: 'DollarSign',
    category: 'insights',
    isNew: true,
  },
  // Google Drive
  {
    id: 'doc-activity',
    connectorId: 'gdrive',
    name: 'Document Activity',
    description: 'Rastrea quién lee y edita documentos clave',
    icon: 'Activity',
    category: 'insights',
  },
  {
    id: 'shared-file-alerts',
    connectorId: 'gdrive',
    name: 'Shared File Alerts',
    description: 'Avisa cuando se comparten archivos externamente',
    icon: 'Share2',
    category: 'alerts',
  },
  // Gmail
  {
    id: 'thread-prioritizer',
    connectorId: 'gmail',
    name: 'Thread Prioritizer',
    description: 'Destaca correos importantes usando IA',
    icon: 'Star',
    category: 'insights',
  },
  {
    id: 'action-item-extractor',
    connectorId: 'gmail',
    name: 'Action Item Extractor',
    description: 'Extrae tareas de los correos entrantes',
    icon: 'CheckSquare',
    category: 'automation',
    isPremium: true,
  },
  {
    id: 'follow-up-reminders',
    connectorId: 'gmail',
    name: 'Follow-up Reminders',
    description: 'Recuerda hacer seguimiento a correos sin respuesta',
    icon: 'BellRing',
    category: 'alerts',
  },
  // Notion
  {
    id: 'notion-page-watcher',
    connectorId: 'notion',
    name: 'Page Watcher',
    description: 'Alertas cuando se actualizan páginas clave en Notion',
    icon: 'Eye',
    category: 'alerts',
  },
  {
    id: 'notion-db-sync',
    connectorId: 'notion',
    name: 'Database Sync',
    description: 'Sincroniza bases de datos de Notion con issues de Jira',
    icon: 'RefreshCw',
    category: 'sync',
    isNew: true,
  },
  {
    id: 'notion-meeting-notes',
    connectorId: 'notion',
    name: 'Meeting Notes',
    description: 'Crea automáticamente notas de reunión en Notion',
    icon: 'FileText',
    category: 'automation',
  },
  {
    id: 'notion-sprint-docs',
    connectorId: 'notion',
    name: 'Sprint Documentation',
    description: 'Genera documentación del sprint automáticamente en Notion',
    icon: 'BookOpen',
    category: 'automation',
    isPremium: true,
  },
]
